import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

let isInitialized = false;

export function initGA(id?: string) {
  if (id && !isInitialized) {
    ReactGA.initialize(id);
    isInitialized = true;
  }
}

export function usePageviewTracking() {
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location.pathname, location.search]);
}
